import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import FilterListIcon from "@material-ui/icons/FilterList";
import { Grid, Toolbar } from "@mui/material";
import Sidebar from "./Sidebar";
import AllQuestions from "./AllQuestions";
import "./css/Main.css";
import "./css/index.css";

function SearchResults() {
  const { query, tagName } = useParams(); // Extract search query & tagName from URL
  const navigate = useNavigate();
  
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Search Results (Triggered when query changes)
  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!query) return;
      try {
        setLoading(true);
        const response = await axios.get(`/api/s`, {
          baseURL: process.env.REACT_APP_FORUM_API,
          params: { query },
        });
        setQuestions(response.data.questions || []);
      } catch (error) {
        setError("Failed to load search results.");
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [query]);

  return (
    <Grid container>
      <Grid item container xs={12}>
        {/* Sidebar */}
        {/* <Grid item xs={2} sx={{ position: "sticky", top: 0, alignSelf: "flex-start", height: "100vh", overflowY: "auto" }}>
          <Toolbar style={{ minHeight: "30px" }} sx={{ height: "0.5rem" }} />
          <Sidebar />
        </Grid> */}

        {/* Main Content */}
        <Grid item xs={10}>
          <div className="main">
            <h4 style={{ marginLeft: "15px" }}>{tagName ? `[${tagName}]` : `[${query}]`}</h4>

            <div className="main-container">
              <div className="main-desc">
                <h6 className="question length">
                  {questions?.length > 0 ? `${questions.length} questions` : `No results found for "${query}"`}
                </h6>

                <div className="main-filter">
                  <div className="main-tabs">
                    <div className="main-tab"><Link to="/">Newest</Link></div>
                    <div className="main-tab"><Link to="/">Active</Link></div>
                    <div className="main-tab"><Link to="/">Bountied</Link></div>
                    <div className="main-tab"><Link to="/">Unanswered</Link></div>
                    <div className="main-tab"><Link to="/">More</Link></div>
                  </div>
                  <div className="main-filter-item">
                    <FilterListIcon />
                    <p className="p2" style={{ marginBottom: "0.3rem" }}>Filter</p>
                  </div>
                </div>
              </div>

              {/* Display Questions */}
              <div className="questions">
                {questions.length > 0 ? (
                  questions.map((_q) => (
                    <div className="question" key={_q._id}>
                      <AllQuestions data={_q} />
                    </div>
                  ))
                ) : (
                  <p>No questions found.</p>
                )}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SearchResults;
